import type { FC } from 'react';

import { LegacyButton } from '@/components/LegacyButton';
import { useRetailerPageContext } from '@/providers/RetailerPageProvider/RetailerPageProviderContext';

import * as S from './RetailerFooter.styles';

interface RetailerFooterProps {
  bannerImage: string;
  cta: string;
  description: string;
  title: string;
}

export const RetailerFooter: FC<RetailerFooterProps> = ({
  bannerImage,
  cta,
  description,
  title,
}) => {
  const { handleDiscoverCollection } = useRetailerPageContext();

  return (
    <S.FooterContainer>
      <S.BannerImage $backgroundImage={bannerImage} />
      <S.TextContainer>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
      </S.TextContainer>
      <LegacyButton onClick={handleDiscoverCollection}>{cta}</LegacyButton>
    </S.FooterContainer>
  );
};
